// export const searchedElementDisplay = (item, search) => {
//   return (
//     !item?.customerMobile.includes(search) &&
//     !item?.name?.toLowerCase().includes(search?.toLowerCase()) &&
//     search?.length > 0
//   );
// };
export const searchedElementDisplay = (item, search) => {
  const name = item?.name || "";
  const mobile = item?.mobile || item?.mobileNumber || "";

  return (
    search?.length > 0 &&
    !name.toLowerCase().includes(search.toLowerCase()) &&
    !mobile.includes(search)
  );
};
